import React from 'react'

import './style.css'

const CourseList = (props) => {

    return (

        <div className="course-list">
            {props.children}
        </div>

    )
}

CourseList.propTypes = {}

export default CourseList


// WEBPACK FOOTER //
// ./src/components/_courses/CourseList/index.js